/**
 * <s-scroll-current>: on load, scrolls its horizontally overflowing child row so the
 * `[aria-current="page"]` item sits in view. Scrolls only the row (never the page),
 * and does nothing when the row doesn't overflow (e.g. wrapped desktop layout).
 */
class ScrollCurrentElement extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => this.#scrollToCurrent());
  }

  #scrollToCurrent() {
    const row = this.firstElementChild;
    const current = this.querySelector('[aria-current="page"]');
    if (!row || !current || row.scrollWidth <= row.clientWidth) return;

    const rowRect = row.getBoundingClientRect();
    const currentRect = current.getBoundingClientRect();
    const offset = currentRect.left - rowRect.left - (rowRect.width - currentRect.width) / 2;
    row.scrollLeft += offset;
  }
}

if (!customElements.get('s-scroll-current')) {
  customElements.define('s-scroll-current', ScrollCurrentElement);
}
